<template>
      <v-card class="mx-auto" shaped elevation="7">
            <v-card-title>
                  Informe Servicio Complementario
                  <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
                  <v-container fluid grid-list-sm>
                        <v-row dense>
                              
                              <v-col cols="12" sm="4">
                                    <v-dialog ref="dialogFechaDesde" v-model="objDate.desde.abrirModal"
                                          :return-value.sync="obSearch.fechaVigenciaIni" persistent width="340px">
                                          <template v-slot:activator="{ on }">
                                                <v-text-field color="textbox" v-model="obSearch.fechaVigenciaIni"
                                                      label="Fecha Desde *" prepend-inner-icon="event" readonly outlined
                                                      dense v-on="on" :rules="requeridoRegla" />
                                          </template>
                                          <v-date-picker color="primary" v-model="obSearch.fechaVigenciaIni" scrollable
                                                locale="es">
                                                <v-spacer></v-spacer>
                                                <v-btn outlined dense rounded color="danger"
                                                      @click="objDate.desde.abrirModal = false" v-html="'Salir'">
                                                </v-btn>
                                                <v-btn rounded dark color="primary"
                                                      @click="$refs.dialogFechaDesde.save(obSearch.fechaVigenciaIni);"
                                                      v-html="'Guardar Fecha'"></v-btn>
                                          </v-date-picker>
                                    </v-dialog>
                              </v-col>
                              <v-col cols="12" sm="4">
                                    <v-dialog ref="dialogFechaHasta" v-model="objDate.hasta.abrirModal"
                                          :return-value.sync="obSearch.fechaVigenciaFin" persistent width="340px">
                                          <template v-slot:activator="{ on }">
                                                <v-text-field color="textbox" v-model="obSearch.fechaVigenciaFin"
                                                      label="Fecha Hasta *" prepend-inner-icon="event" readonly outlined
                                                      dense v-on="on" :rules="requeridoRegla" />
                                          </template>
                                          <v-date-picker color="primary" v-model="obSearch.fechaVigenciaFin" scrollable
                                                locale="es">
                                                <v-spacer></v-spacer>
                                                <v-btn outlined dense rounded color="danger"
                                                      @click="objDate.hasta.abrirModal = false" v-html="'Salir'">
                                                </v-btn>
                                                <v-btn rounded dark color="primary"
                                                      @click="$refs.dialogFechaHasta.save(obSearch.fechaVigenciaFin);"
                                                      v-html="'Guardar Fecha'"></v-btn>
                                          </v-date-picker>
                                    </v-dialog>
                              </v-col>
                              <v-col cols="12" sm="4">
                                    <v-autocomplete label="Proveedor *" color="textbox" v-model="obSearch.idProveedor"
                                          :items="listGeneral.listProveedor" outlined dense />
                              </v-col>

                        </v-row>

                        <v-row dense>
                              <v-col cols="12" sm="4">
                                    <v-autocomplete label="Tipo de Servicio *" color="textbox" v-model="obSearch.idTipoServicioComp"
                                    :items="listGeneral.listTipoServicio"  outlined dense />
                              </v-col>
                              <v-col cols="12" sm="4">
                                    <v-autocomplete label="Estado *" color="textbox" v-model="obSearch.idEstado"
                                    :items="listGeneral.listEstado" item-value="id_estado" item-text="nombre_estado"
                                    outlined dense />
                              </v-col>
                              <v-col cols="12" sm="4">
                                    <v-tooltip top color="primary">
                                          <template v-slot:activator="{ on }">
                                                <v-btn fab dark small color="primary" @click="onListar" v-on="on"
                                                      :disabled="disabled">
                                                      <v-icon dark>search</v-icon>
                                                </v-btn>
                                          </template>
                                          <span>Buscar</span>
                                    </v-tooltip>
                              </v-col>
                        </v-row>

                        <v-row dense>
                              <v-col v-if="_.size(listGeneral.detalle) == 0" cols="12" sm="6"/>
                              <v-col v-else cols="12" sm="6">
                                    <v-btn rounded color="primary" dark @click="exportar('tableInfSerComp','Informe de Servicio Complementario')">Exportar a XLSX</v-btn>
                              </v-col>
                              <v-col cols="12" sm="6">
                                    <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable
                                          dense prepend-inner-icon="search" />
                              </v-col>
                        </v-row>

                        <v-row dense>
                              <v-col cols="12">
                                    <v-data-table :search="obSearch.search" :headers="listGeneral.cabecera" 
                                          :items="listGeneral.detalle" class="elevation-3" id="tableInfSerComp">

                                          <template v-slot:no-results>
                                                Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó
                                                resultados.
                                          </template>
                                    </v-data-table>
                              </v-col>
                        </v-row>
                  </v-container>
            </v-card-text>
      </v-card>
</template>

<script>
      export default {
            name: 'InformeServicioComplementarioView',
            data: () => ({
                  objDate: {
                              desde: { abrirModal: false },
                              hasta: { abrirModal: false },
                        },
                  obSearch: {
                        search: '',
                        fechaVigenciaIni: moment().format('YYYY-MM-DD'),
                        fechaVigenciaFin: moment().format('YYYY-MM-DD'),
                        idProveedor: null,
                        idTipoServicioComp: null,
                        idEstado: null,
                  },
                  listGeneral:{},
                  parametros:{},
                  disabled:false
            }),
            created(){
                  var error = 'E';
                  axios.post(`${BASE_URI}administrador/informe-servicio-complementario/cargaGeneral`)
                       .then((r)=>{
                              if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                              if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                    this.$set(this,'listGeneral',r.data.data.listas);
                                    this.$set(this,'parametros',r.data.data.parametros);
                                    this.obSearch.idEstado = _.toString(this.parametros.id_estado_default);
                                    this.obSearch.idTipoServicioComp = _.get(this.listGeneral,['listTipoServicio','0','value'],null);
                                    return this.onListar('L');
                       })
                       .catch((e)=>{
                             mensajesAlerta(e,error);
                       });
            },
            methods:{
                  onListar(ev){
                        if(!_.isUndefined(ev)){
                              var error = 'E';
                              var o = _.merge(
                                                _.pick(this.obSearch,['fechaVigenciaIni','fechaVigenciaFin','idProveedor','idTipoServicioComp']),
                                                { opcion:'LISTAR' }
                                             );

                              this.listGeneral.detalle = [];
                              axios.post(`${BASE_URI}administrador/informe-servicio-complementario/listar`,o)
                                    .then((r)=>{
                                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                                if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                                      this.listGeneral.detalle = r.data.data;
                                    })
                                    .catch((e)=>{
                                          mensajesAlerta(e,error);
                                    }); 
                        }
                  }
            }
      }
</script>